import { decrypt } from '../utils/crypto';

const encryptedKeys = {
  GITHUB_TOKEN: 'f8f4ac58b52063bbde29653d9ee73e8e:e28a75ffa2b670f890138a1923f3adb0:dMwm6W/JJyiTR18R2wEHXhvAijYIK4YPWvJsyf0FZZM1YorHc1oOxyoJdwifM+SQ',
  EMAILJS_SERVICE_ID: '72bf497b56bfd414e756725b5713b1a4:e98b5702345a62e00b0e26f71e3d974c:GNQQ1JUSvd0kF36Z6qYXGA==',
  EMAILJS_TEMPLATE_ID: 'bf2035e2dd0922b0b56c823c18bf70c3:811932c6529edc956cfe2c0c3081d356:u5a0W01e+ivBI7AXGaJjpjuXTWRKfhyLIJTNaoxWLHk=',
  EMAILJS_PUBLIC_KEY: 'a0db53a6a5272db8ae32c85ac33eec85:e87e1cc4f826452b5b003108efcb69ec:9GHwL3GCTGN372iyNKZe5JDrdgopgdOavB4qJeJTB9A='
};

export const getKey = (keyName) => {
  try {
    const encryptedValue = encryptedKeys[keyName];
    if (!encryptedValue) return null;
    return decrypt(encryptedValue);
  } catch {
    return null;
  }
};